import {
  Box,
  Button,
  Fade,
  List,
  ListItemButton,
  Popper,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import MaButton from "../../UI/ma-button";
import { COLORS } from "../../../STYLES/color";

const DesktopSearchPopup = ({
  handleClose,
  data,
  anchorEl,
  id,
  filteredData,
  navigateToSearchResults,
  query,
  open,
}) => {
  return (
    <>
      <Popper
        transition
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={{ top: 160, left: 500 }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Box
              sx={{
                zIndex: 1000,
                p: 2,
                bgcolor: "#fff",
                mt: 2,
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                maxHeight: "300px",
                overflow: "scroll",
                "&::-webkit-scrollbar": { display: "none" },
              }}
            >
              {(data && data?.searchGlobalInput?.length === 0) || !data ? (
                <>
                  <Typography sx={{ color: "#23263B", fontWeight: 600 }}>
                    Sorry, <br />
                    we didn’t find any matches for "{query}"
                  </Typography>
                  <Typography sx={{ mt: 1.5, color: "#333", fontWeight: 400 }}>
                    Try the following:
                  </Typography>
                  <ul className="no_search_list">
                    <li>Double check your spelling</li>
                    <li>Use fewer keywords</li>
                    <li>
                      Search fo an item that is less specific and refine results
                    </li>
                  </ul>
                </>
              ) : (
                <>
                  <List sx={{ width: "450px" }}>
                    {filteredData?.map((item, index) => (
                      <Link
                        to={
                          item.source == "product"
                            ? `/product-view/${item?.result?._id}`
                            : `/service-view/${item?.result?._id}`
                        }
                        key={index}
                      >
                        <ListItemButton>
                          <SearchSharpIcon sx={{ color: COLORS.TEXT_BLACK }} />
                          {item?.source == "product" ? (
                            <Typography
                              sx={{ ml: 2, color: COLORS.TEXT_BLACK, fontSize: "13px" }}
                            >
                              {item?.result?.name}
                            </Typography>
                          ) : (
                            <Typography
                              sx={{ ml: 2, color: COLORS.TEXT_BLACK, fontSize: "13px" }}
                            >
                              {item?.result?.title}
                            </Typography>
                          )}
                          <Typography
                            variant="label"
                            sx={{ fontSize: "11px", color: "#b3b3b3", ml: 1, }}
                          >{`(${item?.source})`}</Typography>
                        </ListItemButton>
                      </Link>
                    ))}
                  </List>

                  {/* Expand Search Button for Desktop Modal */}
                  {query.trim() && filteredData?.length > 0 && (
                    <Box sx={{ p: 2, borderTop: "1px solid #f0f0f0" }}>
                      <MaButton
                        onClick={() => {
                          navigateToSearchResults(query);
                        }}
                        variant={"primary"}
                        title={" View All Results"}
                        fullWidth
                        startIcon={<SearchIcon />}
                      />
                    </Box>
                  )}
                </>
              )}
            </Box>
          </Fade>
        )}
      </Popper>
    </>
  );
};

export default DesktopSearchPopup;
